import React from 'react';

import useBetaFeature from '@/hooks/useBetaFeature';

import './styles.css';
import type { Props } from './types';

/**
 * Shows the beta to users who have it on, and what it replaces to everyone else.
 *
 * Once the beta is released, swap the gate for its children and delete the fallback.
 */
const BetaGate = ({ children, fallback, feature }: Props) => {
  const { isEnabled } = useBetaFeature(feature);

  return <>{isEnabled ? children : fallback}</>;
};

export default React.memo(BetaGate);
